export default __webpack_public_path__ + "static/home-main-md-a670514cfa12c1797bb8e05424ea786f.jpg";